"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _modalUtils = require("../utils/modalUtils");
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _messages = require("./messages");
var _getLanguage = _interopRequireDefault(require("../utils/getLanguage"));
var _TabbingTrapper = _interopRequireDefault(require("../TabbingTrapper"));
var _Modal_css = _interopRequireDefault(require("./Modal_css"));
// Breaks IE 11 for some reason...

//import { LoadingMain } from "../Loading";

class Modal extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_modal", _Modal_css.default);
    this.language = (0, _getLanguage.default)();

    // get the element the flyout will be injected into
    this.modalRoot = (0, _modalUtils.getModalRoot)();
    this.el = document.createElement("div");
    this.close = this.closeModal.bind(this);
    this.applyWrapper = this.applyWrapper.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.btns = this.props.buttons;
    this.setPositionStyles = this.setPositionStyles.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.state = {
      baseElSet: false,
      positionStyles: {}
    };
  }
  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    this.modalRoot.appendChild(this.el);
    this.setState({
      baseElSet: true
    });
    if (this.props.anchorId) {
      this.setPosition();
    }
  }
  componentWillUnmount() {
    this.modalRoot.removeChild(this.el);
    this.setState({
      baseElSet: false
    });
  }
  setPosition() {
    let anchorElem = document.getElementById(this.props.anchorId);
    if (!anchorElem) {
      return;
    }
    let positionStyles = (0, _modalUtils.setFlyoutPosition)(anchorElem, this.props.alignment, this.props.offset, 0, this.props.fixedPosition);
    this.setPositionStyles(positionStyles);
  }
  setPositionStyles(positionStyles) {
    this.setState({
      positionStyles
    });
  }
  handleButtonClick(btn) {
    if (btn.onClick) {
      if (btn.closeOnClick) {
        btn.onClick(this.close);
      } else {
        btn.onClick(null);
      }
    } else if (btn.closeOnClick) {
      this.close();
    }
  }
  renderButtons() {
    if (this.btns !== null) {
      let btns = this.btns.map((btn, index) => {
        let btnProps = {};
        if (btn.type) btnProps["type"] = btn.type;
        if (btn.displayStyle) btnProps["displayStyle"] = btn.displayStyle;
        if (btn.size) btnProps["size"] = btn.size;
        if (btn.isDisabled) btnProps["isDisabled"] = btn.isDisabled;
        if (btn.themeColor) btnProps["themeColor"] = btn.themeColor;
        return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
          key: `modal-btn-${btn.value}-${index}`
        }, btnProps, {
          onClick: () => this.handleButtonClick(btn)
        }), btn.value);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ModalContainer--actions"
      }, btns);
    } else {
      return null;
    }
  }
  closeModal() {
    if (this.props.onClose !== null) {
      this.props.onClose();
      this.setState({
        positionStyles: {}
      });
      (0, _modalUtils.handleFocusElement)(this.props.focusOnClose);
    }
  }
  applyWrapper() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ModalContainer ${this.props.className}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ModalContainer--overlay",
      onClick: this.close
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("ModalContainer--wrapper", {
        anchored: this.props.anchorId,
        [`position--${this.props.position}`]: true
      })
    }, /*#__PURE__*/_react.default.createElement(_TabbingTrapper.default, {
      escCallback: this.close,
      focusElement: this.props.focusOnOpen
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("ModalContainer--modal", {
        [`radius--${this.props.radius}`]: true,
        "no-padding": this.props.defaultPadding !== true
      }),
      style: this.state.positionStyles,
      role: "dialog",
      "aria-modal": "true"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ModalContainer--content"
    }, this.props.children), this.renderButtons(), !this.btns && this.props.onClose && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "button",
      title: _messages.messages[this.language].close,
      icon: "close",
      className: "ModalContainer--close-icon",
      onClick: this.close
    })))));
  }
  render() {
    if (!this.state.baseElSet) return null;
    return /*#__PURE__*/_reactDom.default.createPortal(this.applyWrapper(), this.el);
  }
}
Modal.propTypes = {
  /** An array of config detail for buttons that will get displayed within the modal */
  buttons: _propTypes.default.arrayOf(_propTypes.default.object),
  /** A css class name added to the this instance of the modal */
  className: _propTypes.default.string,
  /** Boolean to apply (or not) some padding to modal container. */
  defaultPadding: _propTypes.default.bool,
  /** Function to call onClose of the modal */
  onClose: _propTypes.default.func,
  /* working: PropTypes.bool, */

  /** An anchor element to create an anchor line for the modal to attach to vertically */
  anchorId: _propTypes.default.string,
  /** Tells the anchor whether to attach the top or bottom of the Modal to the anchor line */
  alignment: _propTypes.default.oneOf(["modalTop", "modalBottom"]),
  /** Vertical positioning of the modal relative to the browser window. anchorId/alignment take precedence when present. */
  position: _propTypes.default.oneOf(["top", "bottom", "center"]),
  /** Border radius for the modal. */
  radius: _propTypes.default.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /** CSS query selector value for the element that should recieve initial focus */
  focusOnOpen: _propTypes.default.string,
  /** react REF object for the focusable element that should be refocused when the modal closes */
  focusOnClose: _propTypes.default.object
};

/** button object example
 * label should always be there, everything else is optional
  [
    {
      label: "Cancel",
      displayStyle: "primary",
      closeOnClick: true
    },
    {
      label: "Complete Purchase",
      displayStyle: "secondary",
      closeOnClick: false,
      onClick: this.handlePurchasePoints
    }
  ]
*/

Modal.defaultProps = {
  buttons: null,
  className: "",
  defaultPadding: true,
  onClose: null,
  /* working: false */
  anchorId: "",
  alignment: "modalTop",
  position: "top",
  radius: "xs",
  focusOnOpen: null,
  focusOnClose: null
};
var _default = exports.default = Modal;